module.exports = __webpack_public_path__ + "images/eosffc.fac0.png";